import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface Props extends QueryGlobalInterface {
  enabled?: boolean;
  idRegionalVendas?: string | number;
}

export function useListarConsolidados(props: Props) {
  const fetchData = async () => {
    const url = props.idRegionalVendas
      ? `/locais/common/produtos/listar-consolidados/v1/${props.idRegionalVendas}`
      : `/locais/common/produtos/listar-consolidados/v1`;
    const response = await instance.get(url);
    return response?.data;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey || "listar-consolidados", props.idRegionalVendas],
    refetchOnWindowFocus: false,
    enabled: props.enabled ?? true,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar consolidados. Motivos:\n ${error.response?.data?.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
